import React from "react";
import BackgroundCode from "./components/BackgroundCode";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import MonitorDisplay from "./components/MonitorDisplay";
import About from "./components/About";
import Services from "./components/Services";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import BackgroundImage from "./components/BackgroundImage";

export default function App() {
  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      {/* Background with noise texture */}
      <div className="fixed inset-0 bg-[#030303] z-0" style={{ 
        backgroundImage: `
          radial-gradient(circle at center, rgba(255,255,255,0.03) 0%, transparent 100%),
          url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.05'/%3E%3C/svg%3E")
        `,
        backgroundBlendMode: 'overlay'
      }} />
      
      <BackgroundImage />
      <div className="hidden md:block">
        <BackgroundCode />
      </div>
      
      <div className="relative z-10">
        <Navbar />
        <Hero />
        <MonitorDisplay />
        <About />
        <Services />
        <Skills />
        <Projects />
        <Contact />
      </div>
    </div>
  );
}
